import React from 'react';
import './formDisplayGroup.scss';
import { toast } from 'react-toastify';
import { toastOptions } from 'helpers/colorConstants';

function FormDisplayGroup({
	fieldLabel,
	fieldValues,
	fieldValue,
	icon,
	toCopy,
	classValue,
}) {
	const handleCopy = (value) => {
		navigator.clipboard.writeText(value);
		toast.success(
			`The link has been copied to your clipboard.`,
			toastOptions,
		);
	};
	return (
		<div className="FormDisplayGroup">
			<label className="FormDisplayGroup__label">{fieldLabel}</label>
			{fieldValues && (
				<>
					{fieldValues?.length > 0 && (
						<div className="FormDisplayGroup__values">
							{fieldValues.map((value) => (
								<span key={value.id} className="FormDisplayGroup__value__grey">
									{value.name}
								</span>
							))}
						</div>
					)}
				</>
			)}
			{!fieldValues && (
				<>
					{toCopy ? (
						<span
							className="FormDisplayGroup__link"
							onClick={() => handleCopy(fieldValue)}>
							{fieldValue ? fieldValue : '--'}
						</span>
					) : (
						<span
							className={`FormDisplayGroup__value ${classValue ? classValue : ''}`}>
							{fieldValue ? fieldValue : '--'}
							{icon && icon}
						</span>
					)}
				</>
			)}
		</div>
	);
}

export default FormDisplayGroup;
